import { Grid } from "@mui/material";
import { getRemoteValue } from "../../Utils/firebase";
import { useMediaQuery } from "../CustomHook/useMediaQuery";
import DesktopFooter from "./DesktopFooter";
import MobileFooter from "./MobileFooter";


export interface FooterProps {
  /**
   * Opens WhatsApp with the specified phone number
   * @param phoneNumber The phone number to open WhatsApp with
   */
  handleWhatsAppClick: () => void;

  /**
   * Opens the mail app with the specified email address
   * @param email The email address to send mail to
   */
  handleMailClick: () => void;

  handleCallCenterClick: () => void;
}

// Default implementation of the interface functions
const defaultFooterProps: FooterProps = {
  handleWhatsAppClick: () => {
    window.open(`${getRemoteValue("colendi_info_whatsapp")}`, "_blank");
  },
  handleMailClick: () => {
    window.open(`mailto:${getRemoteValue("colendi_info_mail")}`, "_blank");
  },
  handleCallCenterClick: () => {
    window.open(`tel:${getRemoteValue("colendi_info_call_center")}`, "_blank");
  }
};


const Footer = () => {
  const isDesktop = useMediaQuery();
  return (
    <Grid item xs="auto">
      {isDesktop ? <DesktopFooter {...defaultFooterProps} /> : <MobileFooter {...defaultFooterProps} />}
    </Grid>
  );
};

export default Footer;
